export const ACCESS_TOKEN_KEY = 'sn-auth-access-token'
export const REFRESH_TOKEN_KEY = 'sn-auth-refresh-token'
